import Wrapper from './Wrapper';
import {useToastsContext} from './Provider';

const ToastsWrapper = Wrapper;
export default ToastsWrapper;

export {
    useToastsContext as useToasts,
}